<div class="wrapper" id="pageContentWrapper">
	<div class="overlay"></div>
	<router-outlet></router-outlet>

	@if(aiSmartSearchEnabled) {
		<angie-lua-ai-smart-search></angie-lua-ai-smart-search>
	}
</div>
